/**
 * Copyright 2021 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
export const closeIconGrey = {
  src: '/images/close-grey.svg',
  alt: 'closeCardInfo',
};
